import { useState } from 'react';
import './stylesheets/Form.css';
import { useNavigate } from 'react-router-dom';

function Form() {
    const [values, setValues] = useState({
        name: '',
        email: '',
        message: ''
    })
    const navigate = useNavigate();
// async function postData(url, data) {
//     const response = await fetch('https://arrivaldesign.co/request/api/submit-form', {
//         method: 'POST', 
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(data)
//     });
//     if (!response.ok){
//         const errorText = await response.text();
//         throw new Error('HTTP error! status: ${response.status}, message: ${errorText}');
//     }
//     if (response.status === 204 || response.status === 20 && response.headers.get('content-length') === '0'){
//         return null;
//     }
//     return response.json();
// }

// Using fetch in your React component 
const handleSubmit = async (e) => { 
    e.preventDefault();  
    const formData = { 
        name: e.target.name.value, 
        email: e.target.email.value, 
        message: e.target.message.value      
    };  
    // const formData = new FormData(e.currentTarget);
    // const body = Object.fromEntries(formData); 
    const response = await fetch('https://arrivaldesign.co/request', {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formData)
        // body
        }
        
    );
    // console.log("form data", formData)
    const result = await response.json();
    
    if (response.ok) {
        console.log(result);
        // return result;
        navigate('/request/api/success');

    }
};
return (
    <form className="form" method="POST" onSubmit={handleSubmit} >
        <label for="name">
            <input
                type= "text"
                id= "name"
                name= "name"
                placeholder= "Name:"
                onChange={e => setValues({...values, name: e.target.value})}
            />
        </label>
        <label for= "email">
            <input
                type= "text"
                id= "email"
                name= "email"
                placeholder= "Email:"
                onChange={e => setValues({...values, email: e.target.value})}
            />
        </label>
        <label className="request" for= "message">
            <textarea
                type= "text"
                id= "message"
                name= "message"
                placeholder= "Message:"
                rows='5'
                onChange={e => setValues({...values, message: e.target.value})}
            />
        </label>

        <input className="submit" type="submit" value= "Submit"/>

    </form>

);

}

export default Form;